<template>
  <div class="pi-container">
    <div class="pi-root-view">
      <div class="menu">
        <router-link
          v-for="(item, index) in menuItemArr"
          :key="index"
          :to="item.url"
          :class="{active: selectedItem === item.url}"
          class="menu-item-container">
          <span class="menu-title">{{ item.title }}</span>
          <span class="arrow-icon"/>
        </router-link>
      </div>
      <div class="content">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'User',
  data () {
    return {
      selectedItem: '',
      menuItemArr: [
        {
          title: '我的订单',
          url: '/p/user/order'
        },
        {
          title: '我的消费',
          url: '/p/user/money'
        },
        {
          title: '我的评价',
          url: '/p/user/comment'
        },
        {
          title: '推荐商家',
          url: '/p/user/recommended_shop'
        },
        {
          title: '个人设置',
          url: '/p/user/setting'
        },
      ]
    }
  },
  watch: {
    // 监听路由变化
    $route (to, from) {
      this.changeNavigatorBar(to.path)
    }
  },
  mounted() {
    // 组件首次加载时判断相应路由，以展示相应内容
    this.changeNavigatorBar(location.pathname)
  },
  methods: {
    /**
     * 切换导航, 默认显示第一个Item
     */
    changeNavigatorBar (key) {
      if (key === '/p/user' || key === '/p/user/') {
        this.$router.push('/p/user/order')
      } else if (key === '/p/user/money/feedback' || key === '/p/user/money/detail') {
        this.selectedItem = '/p/user/money'
      } else {
        this.selectedItem = key
      }
    }
  }
}
</script>

<style lang="less" scoped>
.pi-container {
  width: 100%;
  height: calc(~"100% - 95px");
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  .pi-root-view {
    width: 1200px;
    min-width: 1200px;
    height: 100%;
    display: flex;
    flex-direction: row;
    .menu {
      width: 230px;
      height: 100%;
      background-color: #ffffff;
      border-radius: 2px;
      border: solid 1px #e5e5e5;
      .menu-item-container {
        width: 180px;
        height: 20px;
        margin-top: 25px;
        margin-left: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-decoration: none;
        font-size: 16px;
        color: #333333;
        .arrow-icon {
          width: 6px;
          height: 10px;
          background-image: url('../../static/img/user/icon_next.png')
        }
      }
      .menu-item-container:hover {
        color: #ff9a28;
        .arrow-icon {
          background-image: url('../../static/img/user/icon_next_sel.png')
        }
      }
      .active {
        color: #ff9a28;
        .arrow-icon {
          background-image: url('../../static/img/user/icon_next_sel.png')
        }
      }
    }
    .content {
      width: 960px;
      height: 100%;
      display: flex;
      justify-content: center;
      margin-left: 10px;
      background-color: #ffffff;
      border-radius: 2px;
      border: solid 1px #e5e5e5;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user.vue